import { Type, TemplateRef } from "@angular/core"

export interface DropdownOptions {
  positionX: 'left' | 'right'
  positionY: 'top' | 'bottom'
  backgroundColor: string | undefined
  cssClass: string | string[] | undefined
  padding: string | number | [number, number] | [number, number, number] | [number, number, number, number] | undefined
  offset: number
  width: number | string | undefined
  height: number | string | undefined
  minWidth: number | string | undefined
  minHeight: number | string | undefined
  maxWidth: number | string | undefined
  maxHeight: number | string | undefined
  destroyOnClick: boolean
}

export const defaultDropdownOptions: DropdownOptions = {
  positionX: 'left',
  positionY: 'bottom',
  backgroundColor: undefined,
  cssClass: undefined,
  padding: undefined,
  offset: 4,
  width: undefined,
  height: undefined,
  minWidth: undefined,
  minHeight: undefined,
  maxWidth: undefined,
  maxHeight: undefined,
  destroyOnClick: true,
}

export interface DropdownComponentContent {
  component: Type<unknown>
  inputs?: Record<string, unknown>
}

export interface DropdownTemplateContent {
  template: TemplateRef<unknown>
  context?: Record<string, unknown>
}

export type DropdownContent =
  | Type<unknown>
  | TemplateRef<unknown>
  | string
  | DropdownComponentContent
  | DropdownTemplateContent

export interface DropdownInputs {
  content: DropdownContent
  options: DropdownOptions
}

export interface DropdownEvent {
  show: boolean
}
